import { commonSbEnv } from "./env.sb.common";

const env: Partial<typeof commonSbEnv> = {
  production: true,
  page: 'conferinta-sb',
  pageCode: 'sbmd',
  meta: {
    siteTitle: 'Stiinta Banilor & Friends 2024',
    ogSiteName: 'Stiinta Banilor',
    siteDescription: 'Vizionează înregistrările',
    ogImageAlt: '',
    ogUrl: 'https://stiintabanilor.ro/cursuri/conferinta-stiintabanilo-2024/',
    ogImage: 'https://stiintabanilor.ro/cursuri/conferinta-stiintabanilor-2024/assets/images/conferinta-sb/cover-fb-inregistrari.png'
  }
};

export const environment = { ...commonSbEnv, ...env };
